export interface TstatuscompanyI {
    tstatuscompanyresponse: IAutoAssignStatus[];
}

export interface IAutoAssignStatus {
    tripsid: number[];
    tripid: number;
    changedsuccessfull: boolean;
    error: string;
    consecutive: number;
}

export interface IAutoAssignSummary {
    message: string;
    total: number;
    previouslyAssigned: number;
    assigned: number;
    unable: number;
    providerAmountZero: number;
    excludedProvider: number;
}

export const AutoAssignMessages = {
    PreviouslyAssigned: 'Previously Assigned',
    UnableToAssigned: 'Unable To Assigned',
    ProviderAmountZero: 'Change of provider is not allowed because the provider amount is 0',
    ExcludedProvider: 'Excluded Provider'
};



// WEBPACK FOOTER //
// ./src/app/core/interfaces/auto-assign.interface.ts